module.exports = __webpack_public_path__ + "img/26.50d8d90a.jpg";